import * as React from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { useEffect, useState } from 'react';
import { useNotifyMessage } from '../../hooks/useNotifyMessage';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />;
});

export function NotificationMessage(): JSX.Element | null {
  const [isOpen, setOpen] = useState(false);
  const { alert } = useNotifyMessage();
  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (alert?.message) {
      setOpen(true);
    }
  }, [alert]);

  return (
    <React.Fragment>
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Snackbar open={isOpen} autoHideDuration={2000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
          <Alert onClose={handleClose} severity={alert?.type} sx={{ width: '100%' }}>
            {alert?.message}
          </Alert>
        </Snackbar>
      </Stack>
    </React.Fragment>
  );
}
